import type { DataSource } from '@unifyapps/defs/types/dataSource';
import DataSourceHelper from '../../../../../helper/DataSourceHelper';
import { useGetDataSourceRecord } from '../../../hooks/useGetDataSourceRecord';
import useAggregationFieldQueryNode from './useAggregationFieldQueryNode';

function AggregationFieldQueryNode({ dataSourceId }: { dataSourceId: string }) {
  const dataSourceRecord = useGetDataSourceRecord().getDataSourceRecord(dataSourceId);
  const dataSource = dataSourceRecord
    ? (DataSourceHelper.properties(dataSourceRecord) as DataSource)
    : undefined;

  useAggregationFieldQueryNode({ dataSourceId, dataSource });

  return null;
}

export default AggregationFieldQueryNode;
